jQuery(document).ready(function ($) {
    'use strict';

    if( $('.parallax').length > 0 ) {
        $('head').append('<script src="/wp-content/themes/kragga.se/static/simpleParallax.min.js"><\/script>');

        var image = document.querySelectorAll('.parallax img');
        new simpleParallax(image, {
            delay: .6,
            transition: 'cubic-bezier(0,0,0,1)',
            scale: 1.5
        });

    }

});